import React, { useState } from "react";
import ActiveFormModal from "../ActiveFormModal";
import defaultimg from "../../assets/img/dummy.jpeg";
import { getAllItems, updateItem } from "../../actions/itemActions";
import { useDispatch } from "react-redux";
const AdminItemListRow = ({ current, i }) => {
  const [showActiveModal, setshowActiveModal] = useState(false);
  const openActiveModal = () => {
    setshowActiveModal((showActiveModal) => !showActiveModal);
  };
  console.log(current, "current");

  const dispatch = useDispatch();
  // const [values, setValues] = useState({
  //   _id: "",
  //   status: "",
  // });
  const handleSubmit = async (event) => {
    console.log("handleSubmit modal k bhr");

    event.preventDefault();
    const updatedStatus = !current.status; // Toggle the boolean value
    const statusData = {
      _id: current.id,
      status: updatedStatus, // Assign the toggled value
    };
    dispatch(updateItem(statusData));

    setTimeout(() => {
      dispatch(getAllItems());
    }, 1000);
    setshowActiveModal(false);
  };
  return (
    <>
      <tr key={i}>
        <td>849</td>
        {/* <td>
          <img
            src={
              current?.itemPic?.fileUrl ? current?.itemPic?.fileUrl : defaultimg
            }
            className="rounded border default-pic-height"
            alt=""
            width="50"
            height="50"
          />
        </td> */}
        <td>
          <img
            src={
              current?.itemPic?.fileUrl ? current?.itemPic?.fileUrl : defaultimg
            }
            className="rounded border default-pic-height"
            alt=""
            width="50"
            height="50"
          />{" "}
          {current?.name}
        </td>
        <td>{current?.storeId?.name}</td>
        <td>${current?.sellPrice}</td>
        <td>Yes</td>
        <td>0 / (0) </td>
        {/* <td>
          <span className="badge bg-dark"> No</span>
        </td> */}
        <td>
          <span className="badge bg-dark"> No</span>
        </td>
        <td>
          {current.status === true ? (
            <a
              href="#"
              className="btn btn-sm btn-success"
              onClick={openActiveModal}
            >
              Active
            </a>
          ) : (
            <a
              href="#"
              className="btn btn-sm btn-dark"
              onClick={openActiveModal}
            >
              Deactivated
            </a>
          )}
        </td>
      </tr>
      <ActiveFormModal
        openActiveModal={openActiveModal}
        showActiveModal={showActiveModal}
        current={current}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default AdminItemListRow;
